/** Application configuration constants */

import { USER_ROLE } from "./constants";
import { ENV, IS_PROD, IS_DEV, BRAND_REQUEST_TEMPLATE_BASE_URL } from "./env";
export { ENV, IS_PROD, IS_DEV, BRAND_REQUEST_TEMPLATE_BASE_URL };

const getHostnameFromUrl = (url?: string) => {
  try {
    return new URL(String(url)).hostname;
  } catch {
    return "";
  }
};

export const BASE_URL = ENV.API_BASE_URL;
export const REPORTING_BASE_URL = ENV.REPORTING_BASE_URL;

export const API_BASE_URL = BASE_URL + "/api";
export const API_BASE_URL_REPORT = REPORTING_BASE_URL + "/report/micro";

export const API_BASE_URL_OPEN = `${API_BASE_URL}/open`;
export const API_BASE_URL_ADMIN = `${API_BASE_URL}/admin`;

export const IPINFO_API_URL = ENV.IPINFO_API_URL;
export const IPIFY_API_URL = ENV.IPIFY_API_URL;

export const STRIPE_MICRO_SERVICE_API_BASE_URL =
  ENV.STRIPE_MICRO_SERVICE_API_BASE_URL + "/api/v1";

export const SOCKET_URL_ADMIN = ENV.SOCKET_URL_ADMIN;
export const SOCKET_URL_API = ENV.SOCKET_URL_API;

export const SITE_URL = ENV.SITE_URL;
export const WHITE_LABELED_DOMAIN_URL = ENV.WHITE_LABELED_DOMAIN_URL;

export const SITE_NAME =
  ENV.SITE === "locallyperfected" ? "Locally Perfected" : "Hyperlocology";

/** User Role **/
export const getUserRole = (id: number | string) => {
  switch (parseInt(String(id))) {
    case USER_ROLE.SUPER_ADMIN.ID:
      return USER_ROLE.SUPER_ADMIN.NAME; // super admin
    case USER_ROLE.PARENT_COMPANY.ID:
      return USER_ROLE.PARENT_COMPANY.NAME; // parent company user
    case USER_ROLE.BRAND_OWNER.ID:
      return USER_ROLE.BRAND_OWNER.NAME; // brand owner user
    case USER_ROLE.PARTICIPANT.ID:
      return USER_ROLE.PARTICIPANT.NAME; // participant user
    case USER_ROLE.BRAND_USER.ID:
      return USER_ROLE.BRAND_USER.NAME; // brand user
    case USER_ROLE.PARENT_COMPANY_USER.ID:
      return USER_ROLE.PARENT_COMPANY_USER.NAME; // parent company user
    case USER_ROLE.PARENT_COMPANY_SUB_USER.ID:
      return USER_ROLE.PARENT_COMPANY_SUB_USER.NAME; // parent company sub user
    case USER_ROLE.SUB_PARTICIPANT.ID:
      return USER_ROLE.SUB_PARTICIPANT.NAME; // sub participant user

    default:
      return "";
  }
};

/** Stripe public key */
export const STRIPE = ENV.STRIPE_PUBLISHABLE_KEY;

/** Image base URL */
export const IMAGE_BASE_URL = ENV.ADMIN_BASE_URL;

/** AWS */
/** S3 Bucket Name */
export const S3_BUCKET_URL = ENV.S3_BUCKET_URL;

/** Maintenance Mode */
export const MAINTENANCE_MODE = false;
export const MAINTENANCE_MODE_ALLOWED_IPS = [
  "14.99.99.146",
  "183.182.84.76",
  "183.182.84.74",
  "49.249.2.122",
];
export const MAINTENANCE_MODE_COUNTRY = false;
export const MAINTENANCE_MODE_ALLOWED_COUNTRY = ["IN"];

/**
 * @method getCreditCardProcessingFee
 * @description return stripe credit card processing fee on given amount
 * @param {*} amount
 * @returns
 */
export const getCreditCardProcessingFee = (amount: number, country = "") => {
  let fee =
    parseFloat(String(amount + 0.3)) / (1 - 0.04) - parseFloat(String(amount));

  if (country?.toLocaleLowerCase() === "canada") {
    fee =
      parseFloat(String(amount + 0.3)) / (1 - 0.045) -
      parseFloat(String(amount));
  }

  return parseFloat(fee?.toFixed(2));
};

export const STRIPE_MAX_AMOUNT = 999999.98; // in USD

export const IS_WHITE_LABELED_DOMAIN =
  typeof window !== "undefined" &&
  !window.location.hostname.includes("hyperlocology.com") &&
  window.location.hostname.includes("locallyperfected.com");

export const IS_HYPER_LOGIN_PAGE =
  typeof window !== "undefined" &&
  getHostnameFromUrl(SITE_URL).endsWith("hyperlocology.com") &&
  window.location.hostname === getHostnameFromUrl(SITE_URL);

export const IS_LOCAL_HOST =
  typeof window !== "undefined" &&
  window.location.hostname.includes("localhost");
